import { getServiceURL } from '@opengov/api-deprecated';

import { IOgqlQueryResult, IQueryRequestParams } from '../ogql-types/src/ogql';

export async function runQuery(
  params: IQueryRequestParams,
  clientOptions?: RequestInit,
  hostUrl?: string
): Promise<IOgqlQueryResult> {
  const { queryString: query, lensId, viewId } = params;

  if (lensId) {
    return getServiceURL(hostUrl)
      .options(clientOptions, true)
      .url('/api/query/v1')
      .query({ lens_id: lensId })
      .body(query)
      .post()
      .json<IOgqlQueryResult>();
  }

  return getServiceURL(hostUrl)
    .options(clientOptions, true)
    .url('/api/query/v1')
    .query({ view_id: viewId })
    .body(query)
    .post()
    .json<IOgqlQueryResult>();
}
